const modelFunctionCache = new WeakMap<any, Map<string, (model: any) => any>>();

function createPathReader(path: string): (model: any) => any {
	if (!path) {
		return (model: any) => model;
	}

	if (path.indexOf('.') === -1) {
		return (model: any) => model[path];
	}

	const keys = path.split(".");
	return (model: any) => {
		let current = model;
		for (let i = 0; i < keys.length; i++) {
			if (current == null) return undefined;
			current = current[keys[i]];
		}
		return current;
	};
}

export default function readNestedProperty(model: any, path: string): any {
	if (!path) {
		return model;
	}

	let pathMap = modelFunctionCache.get(model);
	if (!pathMap) {
		pathMap = new Map<string, (model: any) => any>();
		modelFunctionCache.set(model, pathMap);
	}

	let readFunction = pathMap.get(path);
	if (!readFunction) {
		readFunction = createPathReader(path);
		pathMap.set(path, readFunction);
	}

	return readFunction(model);
}
